import React from 'react'
import { Box } from '@mui/material'
import { DataGrid, GridColDef, GridRowsProp, GridValidRowModel } from '@mui/x-data-grid'

interface IScrollableTableProps<T extends GridValidRowModel = any> {
  data: T[]
  columns: GridColDef[]
  height?: number
  getRowId?: (row: T) => string | number
}

const ScrollableTable = <T extends GridValidRowModel>({
  data,
  columns,
  height = 368,
  getRowId = (row: T) => (row as any)?.id || (row as any)?.rowId || Math.random()
}: IScrollableTableProps<T>) => {
  return (
    <Box sx={{ height, width: '100%' }}>
      <DataGrid
        rows={data}
        columns={columns}
        getRowId={getRowId}
        checkboxSelection={false}
        hideFooter={true}
        rowHeight={52}
        disableColumnMenu
        disableColumnFilter
        disableRowSelectionOnClick
        sx={{
          border: 'none',
          '& .MuiDataGrid-main': {
            overflow: 'auto'
          },
          '& .MuiDataGrid-virtualScroller': {
            overflow: 'auto !important'
          },
          '& .MuiDataGrid-columnSeparator': {
            display: 'none'
          },

          '& .MuiDataGrid-columnHeader:focus': {
            outline: 'none',
          },
          '& .MuiDataGrid-columnHeader:focus-within': {
            outline: 'none',
          },

          '& .MuiDataGrid-cell:focus': {
            outline: 'none',
          },
          '& .MuiDataGrid-cell:focus-within': {
            outline: 'none',
          },

          '& .MuiDataGrid-columnHeader.columnGroupTitle .MuiDataGrid-columnHeaderTitleContainer': {
            justifyContent: 'center'
          },
          '& .MuiDataGrid-columnHeader.centered .MuiDataGrid-columnHeaderTitleContainer': {
            justifyContent: 'center'
          },

          '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: 700,
          },
          '& .MuiDataGrid-columnHeaderDraggableContainer': {
            width: 'auto',
          },
          background: 'transparent'
        }}
      />
    </Box>
  )
}

export default ScrollableTable